import { render } from "./TeamIcons.vue?vue&type=template&id=3e869e88"
import script from "./TeamIcons.vue?vue&type=script&lang=js"
export * from "./TeamIcons.vue?vue&type=script&lang=js"

import "./TeamIcons.vue?vue&type=style&index=0&id=3e869e88&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__